<button [disabled]="isLoading" class="mb-5" *ngIf="isCampaignReview" mat-raised-button (click)="onBackButtonClicked()" >Back
    <mat-icon>arrow_back</mat-icon>
</button>

<h1 class="mb-0">Call Logs</h1>
<h4 *ngIf="!isCampaignReview">Calls received by your agent</h4>
<h4 *ngIf="isCampaignReview">Calls made by your agent during campaign</h4>

<mat-divider class="mt-5 mb-5"></mat-divider>

<div class="mt-1">
    <button mat-raised-button class="d-block mb-4 ms-auto" (click)="onClearFilterClicked()">
        <mat-icon inline="true">clear</mat-icon>
        Clear Filters
    </button>
    <div class="d-flex justify-content-between mb-4" *ngIf="callLogResponses">
        <mat-form-field appearance="outline" style="width: 45%;">
            <mat-label>Filter by outcome</mat-label>
            <mat-select [formControl]="outcomeSelectedValue" (selectionChange)="applyFilter()">
                <mat-option *ngFor="let outcome of outcomes" [value]="outcome">{{outcome}}</mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" style="width: 45%;">
            <mat-label>Enter a date range</mat-label>
            <mat-date-range-input [rangePicker]="picker">
                <input matStartDate placeholder="Start date" [formControl]="startDateRangePickerValue">
                <input matEndDate placeholder="End date" [formControl]="endDateRangePickerValue">
            </mat-date-range-input>
            <mat-hint>Filter by date range</mat-hint>
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
    </div>

    <mat-divider class="mt-4 mb-5"></mat-divider>


    <h1 *ngIf="callLogResponses.length == 0">Call logs are empty. Receive calls in order to see the call logs</h1>

    <div class="mat-elevation-z8" [hidden]="callLogResponses.length == 0">
        <table mat-table [dataSource]="dataSource" matSort>

            <ng-container matColumnDef="Date">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
                <td mat-cell *matCellDef="let row"> {{getDateFormat(row.startTime)}} </td>
            </ng-container>

            <ng-container matColumnDef="Phone">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Phone</th>
                <td mat-cell *matCellDef="let row"> {{row.callerPhoneNumber}}</td>
            </ng-container>

            <ng-container matColumnDef="Outcome">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Outcome</th>
                <td mat-cell *matCellDef="let row"> {{row.outcome}} </td>
            </ng-container>

            <ng-container matColumnDef="UserSentiment">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>User Sentiment</th>
                <td mat-cell *matCellDef="let row"> {{row.userSentiment}} </td>
            </ng-container>

            <ng-container matColumnDef="View">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>View</th>
                <td mat-cell *matCellDef="let row">
                    <button mat-raised-button color="primary" [disabled]="isLoading"
                        (click)="onViewClick(row)">View</button>
                </td>
            </ng-container>

            <ng-container matColumnDef="Delete">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Delete</th>
                <td mat-cell *matCellDef="let row;let i = index">
                    <button [disabled]="isLoading" mat-raised-button class="w-100" color="warn" (click)="onDeleteCallLog(row,i)">
                        <span *ngIf="!isLoadingArray[i]">
                            Delete
                        </span>
                        <mat-spinner *ngIf="isLoadingArray[i]" [diameter]="30" [strokeWidth]="3"
                            class="mx-auto mat-spinner"></mat-spinner>
                    </button>
                </td>
            </ng-container>


            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

            <!-- Row shown when there is no matching data. -->
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">No data matching the filter</td>
            </tr>
        </table>

        <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" aria-label="Select page of users"></mat-paginator>
    </div>
</div>
